<template>
  <div :class="`image_${widget.id}`">
    <div v-html="`<style>${options.style.css}</style>`"></div>
    <img v-if="options.url" :class="widget.id" :id="widget.id" :src="options.url" :style="style" @load="loadImg()" />
    <div v-else class="no-content">
      <ImageUpload class="img" />
      <h6 class="choice-text">
        {{ $t('choice') }}
      </h6>
    </div>
    <Spinner v-if="options.loading" id="spinner"></Spinner>
  </div>
</template>

<script>
import WidgetMixin from './Mixin.js'
import Spinner from '@/shared/components/Spinner'
import ImageUpload from '@/assets/image-upload.svg'
import { mapActions } from 'vuex'

export default {
  name: 'ImageWidget',
  i18nOptions: { keyPrefix: 'components.page-editor.widget.image' },
  mixins: [WidgetMixin],
  components: {
    Spinner,
    ImageUpload,
  },
  computed: {
    style() {
      return this.options.staticImg
        ? {
            width: `${this.options.width}px !important`,
            height: `${this.options.height}px !important`,
            maxWidth: 'unset !important',
          }
        : ''
    },
  },
  methods: {
    ...mapActions('landing', ['updateOptions']),
    loadImg() {
      const imgWidth = document.getElementById(this.widget.id).width
      const imgHeight = document.getElementById(this.widget.id).height
      if (this.widget.options.width !== imgWidth || this.widget.options.height !== imgHeight) {
        this.propChanged('', {
          ...this.widget.options,
          width: imgWidth,
          height: imgHeight,
        })
      }
      if (this.widget.onImgLoaded) this.widget.onImgLoaded()
    },
    propChanged(path, value) {
      this.updateOptions({
        id: this.widget.id,
        path,
        value,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
[class^='image_'] {
  height: auto;
  width: 100%;
  vertical-align: middle;
  .no-content {
    background-color: #d6d6d6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
    .img {
      max-width: 40px;
    }
    .choice-text {
      color: #4b546b;
    }
  }
  img {
    max-width: 100%;
  }
}
</style>
